export const ICONS = {
  EDIT: 'edit',
  LOGO: 'logo',
  SKIP_ARROW: 'skip-arrow',
  LOGO1: 'logo1',
  DASHBOARD: 'dashboard',
  MUSIC: 'music',
  UPLOAD: 'upload',
  REPORTS: 'reports',
  FINANCIAL: 'financial',
  PROFILE: 'profile',
  CONTACT_SUPPORT: 'contact-support',
  EMAIL_VERIFY: 'email-verify',
  BIG_UPLOAD: 'big-upload',
  GOOGLE_ICON: 'google-icon',
  DECLINEICON: 'declineIcon',
  EYEON: 'eyeon',
  EYEOFF: 'eyeoff',
  PLAY: 'play',
  PAUSE: 'pause',
  VOLUME: 'volume',
  UP_ARROW: 'up-arrow',
  DOWN_ARROW: 'down-arrow',
  SEARCH_ICON: 'search-icon',
  ADD_ICON: 'add-icon',
  ADD_IMAGE: 'add-image',
  NO_VOLUME: 'no-volume',
  PAUSE_ICON: 'pause-icon',
  NODATA: 'nodata',
  PREVIOUS: 'previous',
  NEXT: 'next',
  MUTE: 'mute',
  VOLUMEICON: 'volume',
  CLOSE_ICON: 'close-icon',
  MEDIA: 'media',
  CLOSE2: 'close2',
  DOCUMENT: 'document',
  DELETE: 'delete',
};
